import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "d-flex gap-4 mb-6" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "d-flex align-items-center gap-7 mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_6 = { class: "d-flex align-items-center gap-4 mb-4" }
const _hoisted_7 = { class: "overflow-auto h-600px" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = ["srcdoc"]
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-6 mt-4 text-end" }

import { ref, computed } from "vue";
import { LanguageTypes } from "@/core/types/LanguageTypes";
import GlobalService from "../../../services/TenantGlobalService";
import { Message } from "@element-plus/icons-vue";
import SendTestEmail from "../components/SendTestEmail.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailTemplateDetail',
  emits: ["eventSubmit"],
  setup(__props, { expose: __expose, emit: emits }) {

const isLoading = ref(false);
const submitted = ref(false);
const drawer = ref(false);

const data = ref(Array<any>());
const title = ref("");
const languageMenu = ref([]);
const selectedLanguage = ref("");

const layoutTemplate = ref({});
const sendTestEmailRef = ref<InstanceType<typeof SendTestEmail>>();

const close = () => {
  languageMenu.value = [];
  selectedLanguage.value = "";
  layoutTemplate.value = {};
  drawer.value = false;
};
const show = (detail, defaultLayout) => {
  data.value = detail;
  layoutTemplate.value = defaultLayout;
  title.value = detail.title;
  getLanguageMenu(detail.contents);
  drawer.value = true;
};
const refreshHtml = (item) => {
  if (item.language in layoutTemplate.value.contents) {
    var t = layoutTemplate.value.contents[item.language].content;
    t = t.replace("{{Title}}", item.title);
    t = t.replace("{{Subtitle}}", item.subtitle);
    t = t.replace("{{Content}}", item.content);
    return t;
  } else {
    return item.content;
  }
};

const sendTest = (title, lang) => {
  sendTestEmailRef.value.show(title, lang);
};

const getLanguageMenu = (detailContents) => {
  const langKeys = Object.keys(detailContents);
  languageMenu.value = LanguageTypes.all.filter(
    (item) => !langKeys.includes(item.code)
  );
  if (languageMenu.value.length > 0) {
    selectedLanguage.value = languageMenu.value[0].code;
  }
};

const addLang = () => {
  if (Object.keys(data.value.contents).length < LanguageTypes.all.length) {
    data.value.contents[selectedLanguage.value] = {
      id: 0,
      language: selectedLanguage.value,
      title: "",
      subtitle: "",
      content: "",
    };
    getLanguageMenu(data.value.contents);
  }
};

const canAddLang = computed(() => {
  return Object.keys(data.value.contents).length < LanguageTypes.all.length;
});
const updateLanguage = async (item) => {
  try {
    await GlobalService.updateEmailLanguage(data.value.id, item.id, item);
    MsgPrompt.success("Update success", item.language);
  } catch (e) {
    console.log(e);
  }
};

const createLanguage = async (item) => {
  try {
    await GlobalService.createEmailLanguage(data.value.id, item);
    MsgPrompt.success("Create success", item.language);
  } catch (e) {
    console.log(e);
  }
};



const submit = (item) => {
  isLoading.value = true;
  submitted.value = true;
  if (item.id == 0) {
    createLanguage(item);
  } else {
    updateLanguage(item);
  }
  emits("eventSubmit");
  isLoading.value = false;
  submitted.value = false;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_drawer, {
      modelValue: drawer.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event)),
      title: title.value,
      direction: "ltr",
      size: "90%",
      "before-close": close
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_select, {
              modelValue: selectedLanguage.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedLanguage).value = $event)),
              disabled: !canAddLang.value
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languageMenu.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.code,
                    label: item.code + '   (' + item.name + ')',
                    value: item.code
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _createVNode(_component_el_button, {
            type: "warning",
            onClick: addLang,
            disabled: !canAddLang.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.addALanguage")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_tabs, { type: "card" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.contents, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  label: index,
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.$t("fields.title")), 1),
                          _createVNode(_component_el_input, {
                            modelValue: item.title,
                            "onUpdate:modelValue": ($event: any) => ((item.title) = $event),
                            class: "w-500px"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _hoisted_5
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.$t("fields.subtitle")), 1),
                          _createVNode(_component_el_input, {
                            label: _ctx.$t('fields.subtitle'),
                            modelValue: item.subtitle,
                            "onUpdate:modelValue": ($event: any) => ((item.subtitle) = $event),
                            class: "w-500px"
                          }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_el_input, {
                            modelValue: item.content,
                            "onUpdate:modelValue": ($event: any) => ((item.content) = $event),
                            type: "textarea",
                            autosize: { minRows: 20 }
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("iframe", {
                          srcdoc: refreshHtml(item),
                          width: "100%",
                          height: "100%"
                        }, null, 8, _hoisted_9)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          plain: "",
                          icon: _unref(Message),
                          onClick: _withModifiers(($event: any) => (sendTest(data.value.title, item.language)), ["prevent"]),
                          disabled: submitted.value || isLoading.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Test")
                          ]),
                          _: 2
                        }, 1032, ["icon", "onClick", "disabled"]),
                        _createVNode(_component_el_button, {
                          type: "danger",
                          onClick: close,
                          disabled: submitted.value || isLoading.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_el_button, {
                          type: "success",
                          onClick: ($event: any) => (submit(item)),
                          loading: submitted.value || isLoading.value,
                          disabled: submitted.value || isLoading.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "loading", "disabled"])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(SendTestEmail, {
      ref_key: "sendTestEmailRef",
      ref: sendTestEmailRef
    }, null, 512)
  ], 64))
}
}

})